<template>
  <AgeCalc/>
</template>

<script>
import AgeCalc from './components/AgeCalc.vue'
export default {
  name: 'App',
  components: {
   AgeCalc
  }
}
</script>

